import { render, staticRenderFns } from "./RequestInventory.vue?vue&type=template&id=436fc1e6&scoped=true"
import script from "./RequestInventory.vue?vue&type=script&lang=js"
export * from "./RequestInventory.vue?vue&type=script&lang=js"
import style0 from "./RequestInventory.vue?vue&type=style&index=0&id=436fc1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436fc1e6",
  null
  
)

export default component.exports